import { FileIcon } from "lucide-react";
import type React from "react";
import { Asset } from "@forgepoint/shared";
import { AssetViewer } from "./AssetViewer";

interface AssetFileViewerProps {
  asset?: Asset;
  className?: string;
  emptyState?: React.ReactNode;
}

/**
 * Container component that routes an asset to the file viewer.
 * Handles the empty state when no asset is provided.
 *
 * @param asset - Optional Asset object for displaying a saved file
 * @param className - Optional CSS classes to apply to the viewer
 * @param emptyState - Optional custom empty state to display when no asset is provided
 * @returns The asset viewer or the empty state
 */
export function AssetFileViewer({
  asset,
  className,
  emptyState,
}: AssetFileViewerProps) {
  if (!asset) {
    if (emptyState) {
      return <>{emptyState}</>;
    }
    return (
      <div
        className={`flex flex-col items-center justify-center h-full text-center ${className || ""}`}
      >
        <FileIcon className="h-16 w-16 text-muted-foreground opacity-20 mb-4" />
        <p className="text-sm text-muted-foreground">
          Select a file to preview
        </p>
      </div>
    );
  }

  return <AssetViewer asset={asset} className={className} />;
}
